export let BillingDayOfMonthType = /*#__PURE__*/function (BillingDayOfMonthType) {
  BillingDayOfMonthType["LastDayOfMonth"] = "lastDayOfMonth";
  BillingDayOfMonthType["DayOfMonth"] = "dayOfMonth";
  return BillingDayOfMonthType;
}({});